

import { Typography } from '@mui/material'
import { useCallback } from 'react'
import { numberFormatterLocale } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { FaSignal, FaChartLine, FaCalculator, FaBuromobelexperte,FaLongArrowAltUp,FaLongArrowAltDown } from "react-icons/fa";

const CardYear = ({ value, nType }) => {

    const jsxElementCard = useCallback(() => {
        if (nType === 1) {
            return (
                <div className="card-container-income color-container-1">
                    <div id="main-icon">
                        <div id="div-icon" className="color-icon-1">
                            <FaSignal className='income-svg' />
                        </div>
                    </div>
                    <div id="div-text-income">
                        <Typography className='title-text'>รายได้ตามแผน</Typography>
                        <Typography className='value-text'>{numberFormatterLocale(value, 2)}</Typography>
                        <Typography>(บาท)</Typography>
                    </div>
                </div>
            )
        }
        else if (nType === 2) {
            return (
                <div className="card-container-income color-container-2">
                    <div id="main-icon">
                        <div id="div-icon" className="color-icon-2">
                            <FaChartLine className='income-svg' />
                        </div>
                    </div>
                    <div id="div-text-income">
                        <Typography className='title-text'>รายได้รวม</Typography>
                        <Typography className='value-text'>{numberFormatterLocale(value, 2)}</Typography>
                        <Typography>(บาท)</Typography>
                    </div>
                </div>
            )
        }
        else if (nType === 3) {
            let isUp = !(numberFormatterLocale(value, 2) <= 90);
            return (
                <div className={ isUp ? "card-container-income color-container-3" : "card-container-income color-container-3-down"}>
                    <div id="main-icon">
                        <div id="div-icon" className={isUp ? "color-icon-3" : "color-icon-3-down"}>
                            <FaCalculator className='income-svg' />
                        </div>
                    </div>
                    <div id="div-text-income">
                        <Typography className='title-text'>สัดส่วนรายได้เทียบแผน</Typography>
                        <Typography className='value-text'>{numberFormatterLocale(value, 2)}</Typography>
                        <Typography>(%)</Typography>
                        { isUp ? <FaLongArrowAltUp className='arrow-ratio'/> : <FaLongArrowAltDown className='arrow-ratio'/>}
                    </div>
                </div>
            )
        }
        else if (nType === 4) {
            return (
                <div className="card-container-income color-container-4">
                    <div id="main-icon">
                        <div id="div-icon" className="color-icon-4">
                            <FaBuromobelexperte className='income-svg' />
                        </div>
                    </div>
                    <div id="div-text-income">
                        <Typography className='title-text'>ประมาณการรายได้ทั้งปี</Typography>
                        <Typography className='value-text'>{numberFormatterLocale(value, 2)}</Typography>
                        <Typography>(บาท)</Typography>
                    </div>
                </div>
            )
        }
    }, [nType, value])


    return (
        <>
            {jsxElementCard()}
        </>

    )
}

export default CardYear